export const COPY = {
  invalidCredentials: 'Incorrect code',
  button: 'Login'
}
